const search = {
  name: '姓名',
  identification: '身份证',
  // logs
  所属机构: '所属机构',
  日志类型: '日志类型',
  登录方式: '登录方式',
  模糊查询: '模糊查询',
  发生时间: '发生时间',
  // alarm
  序列号: '序列号',
  实体: '实体',
  告警状态: '告警状态',
  告警时间: '告警时间',
  // device
  设备类型: '设备类型',
  生产日期: '生产日期',
  选择日期: '选择日期',
  大于: '大于',
  小于: '小于',
  之间: '之间',
  之前: '之前',
  之后: '之后',
  选择时间: '选择时间',
  // supervise
  分组: '分组',
  姓名: '姓名',
  身份证号: '身份证号',
  身份证: '身份证',
  性别: '性别',
  住址: '住址',
  工作单位: '工作单位',
  信用评价: '信用评级',
  备注: '备注',
  // deviceComp
  selectDeviceModel: '请选择设备类型',
  // placeholder
  '设备号/序列号': '设备号/序列号',
  请选择分组: '请选择分组',
  请输入序列号SN: '请输入序列号SN',
  请输入实体姓名: '请输入实体姓名',
  请选择告警状态: '请选择告警状态',
  请选择日志类型: '请选择日志类型',
  请选择登录方式: '请选择登录方式',
  请输入要查询的内容: '请输入要查询的内容',
}
export default search